import React, { useCallback } from "react"
import { FormControlLabel, FormGroup } from "@mui/material"
import MuiSwitch from "@mui/material/Switch"
import { useFormContext, useController } from "react-hook-form"

import { FormField } from "./types"
import styles from "./Forms.module.scss"
import { trackFormEvent } from "./utils"

export interface Props extends FormField {}

const Switch = ({ className, label, name, rules, disabled, tracking }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const handleClick = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      controller.field.onChange(e.currentTarget.checked)

      if (tracking?.shouldTrackValueChange) {
        await trackFormEvent("Form Value Provided", tracking, name, label)
      }
    },
    [controller.field, label, name, tracking]
  )

  return (
    <FormGroup className={className}>
      <FormControlLabel
        classes={{ label: styles.blackText }}
        control={<MuiSwitch onChange={handleClick} checked={controller.field.value || false} />}
        label={label}
        disabled={disabled}
      />
    </FormGroup>
  )
}

export default Switch
